(function () {
    'use strict';

    'use strict';
/**
 * @namespace komondor
 */
angular.module('ng-komondor', ['ui.bootstrap', 'ui.router', 'ui-notification', 'komondor.auth', 'ng-komondor.templates']);
angular.module('ngKomondor', ['ng-komondor']);
'use strict';
/**
 * @namespace ng-komondor.auth
 */
angular.module('komondor.auth', []);
'use strict';
angular.module('ng-komondor').config(["$stateProvider", function ($stateProvider) {
    $stateProvider.state('style-guide', {
        url: '/style-guide/:styleTab',
        templateUrl: 'ng-komondor/style-guide/style-guide.html',
        controller: ["$scope", "styleGuide", "$stateParams", function controller($scope, styleGuide, $stateParams) {
            $scope.styleGuide = styleGuide;
            $scope.stylePage = styleGuide.list.filter(function (item) {
                return item.label === $stateParams.styleTab;
            })[0];
        }],
        params: { styleTab: 'Typography' }
    });
}]);
'use strict';
angular.module('komondor.auth')    /**
 * @memberOf komondor.auth
 * @ngdoc provider
 * @name  kdAuthProvider
 */.provider('kdAuth', function () {
    var initialUser;
    /**
     * @memberOf komondor.auth.kdAuthProvider
     * @function setInitialUser
     * @param {object} user
     */
    this.setInitialUser = function (user) {
        initialUser = user;
    };
    /**
     * @param user
     * @returns {*}
     */
    this.getInitialUser = function () {
        return initialUser;
    };
    /**
     * @memberOf  komondor.auth
     * @ngdoc service
     * @name  kdAuth
     * @property {object} user - the current user
     */
    this.$get = ["$rootScope", function ($rootScope) {
        return {
            user: initialUser,
            /**
             * @memberOf  komondor.auth.kdAuth
             * @param {object} user
             */
            setUser: function setUser(user) {
                this.user = user;
                $rootScope.$broadcast('kdAuth:userChanged');
            }
        };
    }];
});
'use strict';
angular.module('komondor.auth')    /**
 * @memberOf komondor.auth
 * @ngdoc provider
 * @name  kdGateProvider
 */.provider('kdGate', function () {
    this.gates = {};
    this.handlers = {
        before: [],
        after: []
    };
    /**
     * Define an ability and its authorisation callback
     *
     * @memberOf komondor.auth.kdGateProvider
     * @param  {string} ability The name of the ability to define
     * @param  {function} func  The callback to authorise the ability
     *                          With the signature `function (user, arg1, arg2 ...)`
     */
    this.define = function (ability, func) {
        this.gates[ability] = func;
    };
    /**
     * Add a callback before every ability is resolved, if it returns a value
     * then that is used as the result.
     *
     * @memberOf komondor.auth.kdGateProvider
     * @param  {function} func  The callback to authorise the ability
     *                          With the signature `function (user, ability)`
     */
    this.before = function (func) {
        this.handlers.before.push(func);
    };
    /**
     * Add a callback after every ability is resolved
     *
     * @memberOf komondor.auth.kdGateProvider
     * @param  {function} func  The callback to authorise the ability
     *                          With the signature `function (user, ability, result, arguments)`
     */
    this.after = function (func) {
        this.handlers.after.push(func);
    };
    this.$get = ["kdAuth", function (kdAuth) {
        /**
         * @memberOf  komondor.auth
         * @ngdoc service
         * @name  kdGate
         */
        return {
            gates: this.gates,
            handlers: this.handlers,
            /**
             * @memberOf komondor.auth.kdGate
             * @param  {string}  ability
             * @return {Boolean} Whether the ability has been defined
             */
            has: function has(ability) {
                return angular.isDefined(this.gates[ability]);
            },
            /**
             * Determin if the current user is allowed to perform an ability
             *
             * @memberOf komondor.auth.kdGate
             * @param  {string}  ability
             * @return {Boolean}
             */
            check: function check(ability) {
                var args;
                var user = kdAuth.user;
                // Run before callbacks
                var result = this.before(user, ability);
                // If before didn't return a result
                if (!angular.isDefined(result) && this.has(ability)) {
                    // Sort out our arguments
                    var argsWithUser = Array.prototype.slice.call(arguments, 1);
                    args = Array.prototype.slice.call(arguments, 1);
                    argsWithUser.unshift(user);
                    // Resolve the gate
                    result = this.gates[ability].apply(null, argsWithUser);
                }
                // Run after callbacks
                this.after(user, ability, result, args);
                if (!angular.isDefined(result)) {
                    result = false;
                }
                return result;
            },
            before: function before(user, ability) {
                var result;
                var handlers = this.handlers.before;
                for (var i = 0; i < handlers.length; i++) {
                    result = handlers[i](user, ability);
                    if (angular.isDefined(result)) {
                        return result;
                    }
                }
            },
            after: function after(user, ability, result, args) {
                var handlers = this.handlers.after;
                for (var i = 0; i < handlers.length; i++) {
                    handlers[i](user, ability, result, args);
                }
            },
            /**
             * Determin if the current user is allowed to perform an ability
             *
             * @memberOf komondor.auth.kdGate
             * @param  {string}  ability
             * @return {Boolean}
             */
            allows: function allows(ability) {
                return this.check(ability);
            },
            /**
             * Determin if the current user is not allowed to perform an ability
             *
             * @memberOf komondor.auth.kdGate
             * @param  {string}  ability
             * @return {Boolean}
             */
            denies: function denies(ability) {
                return !this.check(ability);
            }
        };
    }];
});
'use strict';
angular.module('komondor.auth')    /**
 * @memberOf komondor.auth
 * @ngdoc directive
 * @name kdGateDirective
 * @scope false
 * @restrict A
 * @description
 *   Hide an element if the user is not allowed to perform an ability
 *   `<div kd-gate="ability-name">`"
 *
 */.directive('kdGate', ["$log", "kdGate", function ($log, kdGate) {
    return {
        restrict: 'A',
        link: function link($scope, element, attrs) {
            function gateElement(ability) {
                if (!ability) {
                    $log.error('kdGate ability cannot be empty', ability);
                    return;
                }
                var negative = ability.charAt(0) === '!';
                var func = 'allows';
                if (negative) {
                    ability = ability.replace(/^[!]+/, '');
                    func = 'denies';
                }
                if (kdGate[func](ability)) {
                    element.removeClass('ng-hide');
                } else {
                    element.addClass('ng-hide');
                }
            }
            gateElement(attrs.kdGate);
            $scope.$on('kdAuth:userChanged', function () {
                gateElement(attrs.kdGate);
            });
        }
    };
}]);
'use strict';
var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ('value' in descriptor)
                descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function (Constructor, protoProps, staticProps) {
        if (protoProps)
            defineProperties(Constructor.prototype, protoProps);
        if (staticProps)
            defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
var CanvasImage = function () {
    CanvasImage.$inject = ["$element", "Hammer", "fabric", "$window", "$timeout"];
    function CanvasImage($element, Hammer, fabric, $window, $timeout) {
        _classCallCheck(this, CanvasImage);
        this.MAX_SCALE = 10;
        this.$element = $element;
        this.Hammer = Hammer;
        this.fabric = fabric;
        this.$window = $window;
        this.$timeout = $timeout;
        this.image = null;
        this.canvas = null;
        this.container = null;
        this.canvasWrap = null;
        this.hammertime = null;
        this.lastEvent = null;
        this.handleScroll = this.handleScroll.bind(this);
        this.setPinchDefaults = this.setPinchDefaults.bind(this);
        this.handlePinch = this.handlePinch.bind(this);
        this.handlePan = this.handlePan.bind(this);
        this.setLastEvent = this.setLastEvent.bind(this);
        this.sizeToContainer = this.sizeToContainer.bind(this);
        this.setImage = this.setImage.bind(this);
        this.resize = this.resize.bind(this);
        this.canvas = new this.fabric.Canvas(this.$element[0].querySelector('canvas'));
    }
    _createClass(CanvasImage, [{
            key: '$onInit',
            value: function $onInit() {
                // Create a hammer instance to fetch pitch and pan events for touchscreen devices
                this.canvasWrap = this.$element.children()[0];
                this.container = this.$element[0].querySelector('.canvas-container');
                this.hammertime = new this.Hammer.Manager(this.container);
    
                this.canvas.selection = false;
                this.canvas.hoverCursor = 'default';
    
                // Add the pinch recognizer
                this.hammertime.add(new this.Hammer.Pinch());
    
                // Add the pan recognizer
                this.hammertime.add(new this.Hammer.Pan());
    
                // Mouse events handlers
                this.$element.bind('DOMMouseScroll mousewheel onmousewheel', this.handleScroll);
    
                this.hammertime.on('pinchstart', this.setPinchDefaults);
    
                this.hammertime.on('pinch', this.handlePinch);
    
                this.hammertime.on('pinchend', this.setPinchDefaults);
    
                this.hammertime.on('panstart', this.setLastEvent);
    
                this.hammertime.on('panmove', this.handlePan);
    
                this.$window.addEventListener('resize', this.resize);
    
                this.setImage();
            }
        }, {
            key: '$onDestroy',
            value: function $onDestroy() {
                this.$window.removeEventListener('resize', this.resize);
            }
        }, {
            key: 'setImage',
            value: function setImage() {
                var _this = this;
    
                this.fabric.Image.fromURL(this.source, function (image) {
                    _this.image = image;
    
                    _this.sizeToContainer();
                    _this.image.hasControls = false;
                    _this.image.hasBorders = false;
                    _this.image.selectable = false;
                    _this.image.minScaleLimit = 1;
    
                    // Cause our scaling to be centered
                    // centeredScaling does work so use origin
                    // this.image.centeredScaling = true;
                    _this.image.originX = 'center';
                    _this.image.originY = 'center';
    
                    _this.canvas.add(_this.image);
                    _this.fitImageBounds();
                });
            }
        }, {
            key: 'sizeToContainer',
            value: function sizeToContainer() {
                var imgRatio = this.image.height / this.image.width;
    
                this.image.width = this.$element[0].offsetWidth;
                this.image.height = this.image.width * imgRatio;
    
                this.canvas.setDimensions({
                    width: this.image.width,
                    height: this.image.height
                });
    
                this.fitImageBounds();
            }
        }, {
            key: 'setLastEvent',
            value: function setLastEvent(event) {
                this.lastEvent = event;
            }
        }, {
            key: 'handleScroll',
            value: function handleScroll(event) {
                event.preventDefault();
    
                var wheelDelta;
    
                if ('wheelDelta' in event) {
                    wheelDelta = event.wheelDelta;
                    // For browsers that don't support wheelDelta prop such as FF
                } else {
                    // The measurement units of the detail and wheelDelta properties are different
                    wheelDelta = -40 * event.detail;
                }
    
                this.scaleRelative(wheelDelta / 1200, event.clientX, event.clientY);
    
                return false;
            }
        }, {
            key: 'handlePan',
            value: function handlePan(event) {
                if (this.image.scaleX > 1) {
                    this.canvas.upperCanvasEl.style.cursor = 'move';
                    this.pan(event.deltaX - this.lastEvent.deltaX, event.deltaY - this.lastEvent.deltaY);
                    this.fitImageBounds();
    
                    this.lastEvent = event;
                }
            }
        }, {
            key: 'pan',
            value: function pan(modX, modY) {
                this.canvas.relativePan(new this.fabric.Point(modX, modY));
            }
        }, {
            key: 'setPinchDefaults',
            value: function setPinchDefaults() {
                this.pinchCenter = null;
            }
        }, {
            key: 'handlePinch',
            value: function handlePinch(event) {
                if (!this.pinchCenter) {
                    this.pinchCenter = event.center;
                    this.lastEvent = event;
                    return;
                }
    
                var modScale = event.scale - this.lastEvent.scale;
    
                this.lastEvent = event;
    
                this.scaleRelative(modScale, this.pinchCenter.x, this.pinchCenter.y);
            }
    
            /**
             * @param modScale
             * @param centerX Page coordinates
             * @param centerY Page coordinates
             */
    
        }, {
            key: 'scaleRelative',
            value: function scaleRelative(modScale, centerX, centerY) {
                this.scaleAbsolute(this.image.scaleX + modScale, centerX, centerY);
            }
    
            /**
             * @param modScale
             * @param centerX Page coordinates
             * @param centerY Page coordinates
             */
    
        }, {
            key: 'scaleAbsolute',
            value: function scaleAbsolute(scale, centerX, centerY) {
                var scaleDiff = scale - this.image.scaleX;
    
                this.image.scale(scale);
    
                if (centerX !== undefined) {
                    var rect = this.container.getBoundingClientRect();
    
                    // Co-ords relative to center of image
                    var center = {
                        x: centerX - rect.left - (rect.right - rect.left) / 2,
                        y: centerY - rect.top - (rect.bottom - rect.top) / 2
                    };
    
                    // Pan the oppositie way proportional to the zoom modifier
                    var translate = {
                        x: -center.x * scaleDiff,
                        y: -center.y * scaleDiff
                    };
    
                    this.pan(translate.x, translate.y);
                }
    
                this.fitImageBounds();
                this.canvas.renderAll();
            }
        }, {
            key: 'scaleImage',
            value: function scaleImage(scale) {
                this.image.scale(scale);
    
                if (this.image.scaleX > this.MAX_SCALE) {
                    this.image.scaleX = this.MAX_SCALE;
                    this.image.scaleY = this.MAX_SCALE;
                }
            }
        }, {
            key: 'fitImageBounds',
            value: function fitImageBounds() {
                var imageRect = this.image.getBoundingRect();
                var canvasRect = this.container.getBoundingClientRect();
    
                // If image has a gap on the left
                if (imageRect.left > 0) {
                    this.canvas.relativePan(new this.fabric.Point(-imageRect.left, 0));
                }
    
                // If image has a gap on the top
                if (imageRect.top > 0) {
                    this.canvas.relativePan(new this.fabric.Point(0, -imageRect.top));
                }
    
                // If image has a gap on the right
                var right = imageRect.left + imageRect.width;
                if (right < canvasRect.width) {
                    this.canvas.relativePan(new this.fabric.Point(canvasRect.width - right, 0));
                }
    
                // If image has a gap on the bottom
                var bottom = imageRect.top + imageRect.height;
                if (bottom < canvasRect.height) {
                    this.canvas.relativePan(new this.fabric.Point(0, canvasRect.height - bottom));
                }
            }
        }, {
            key: 'reset',
            value: function reset() {
                this.setImage();
            }
        }, {
            key: 'resize',
            value: function resize() {
                this.$timeout(this.setImage);
            }
        }]);
    return CanvasImage;
}();
angular.module('ng-komondor').component('canvasImage', {
    controller: 'CanvasImage',
    templateUrl: 'ng-komondor/canvas-image/canvas-image.html',
    bindings: { source: '@' }
}).controller('CanvasImage', CanvasImage);
'use strict';
angular.module('ng-komondor').component('checkboxInput', {
    require: 'ngModel',
    bindings: {
        ngModel: '=',
        label: '=',
        name: '=',
        onChange: '=?',
        onChangeArgs: '=?',
        checkboxDisabled: '=?',
        trueValue: '@?',
        falseValue: '@?'
    },
    bindToController: true,
    controllerAs: '$ctrl',
    templateUrl: 'ng-komondor/checkbox-input/checkbox.input.html',
    controller: ["$element", function controller($element) {
        this.ngModelCtrl = $element.controller('ngModel');
        this.$onInit = function () {
            $element.addClass('checkbox-input');
            if (this.checkboxDisabled) {
                this.disable(this.checkboxDisabled);
            }
            if (this.name) {
                var input = $element.find('input');
                input.attr('name', this.name);
            }
            this.trueValue = angular.isUndefined(this.trueValue) ? true : this.trueValue;
            this.falseValue = angular.isUndefined(this.falseValue) ? false : this.falseValue;
        };
        this.updateNgModel = function (value) {
            this.ngModelCtrl.$setViewValue(value);
            if (angular.isFunction(this.onChange)) {
                this.onChange(this.onChangeArgs, value, this.disable);
            }
        };
        this.disable = function (state) {
            this.disabled = state;
        }.bind(this);
    }]
});
'use strict';
/**
 * decorator for nested dropdown directive
 *
 *      patch from https://gist.github.com/sebastianhenneberg/acb0a5e7b0e63006c699 by @sebastianhenneberg
 *      issue discussed at https://github.com/angular-ui/bootstrap/issues/2421
 */
angular.module('ng-komondor').config(["$provide", function dropdownServiceDecorator($provide) {
    $provide.decorator('uibDropdownService', ["$delegate", "nestedDropdownService", function ($delegate, nestedDropdownService) {
        return nestedDropdownService;
    }]);
}]).service('nestedDropdownService', ['$document', '$rootScope', '$$multiMap', function ($document, $rootScope, $$multiMap) {
    var openScopes = [];
    var openedContainers = $$multiMap.createNew();

    var getUpperScope = function getUpperScope() {
        if (openScopes.length === 0) {
            return null;
        }
        return openScopes[openScopes.length - 1];
    };

    this.isOnlyOpen = function (dropdownScope, appendTo) {
        var openedDropdowns = openedContainers.get(appendTo);
        if (openedDropdowns) {
            var openDropdown = openedDropdowns.reduce(function (toClose, dropdown) {
                if (dropdown.scope === dropdownScope) {
                    return dropdown;
                }

                return toClose;
            }, {});
            if (openDropdown) {
                return openedDropdowns.length === 1;
            }
        }

        return false;
    };

    this.open = function (dropdownScope, element, appendTo) {

        var upperScope = getUpperScope();

        if (!upperScope) {
            $document.on('click', closeDropdown);
        }

        while (upperScope && upperScope !== dropdownScope) {
            // contained dropdown, do not close dropdown
            if (upperScope.getElement()[0].contains(dropdownScope.getElement()[0])) {
                break;
            }

            openScopes.pop().isOpen = false;
            upperScope = getUpperScope();
        }

        openScopes.push(dropdownScope);

        if (!appendTo) {
            return;
        }

        var openedDropdowns = openedContainers.get(appendTo);

        if (openedDropdowns) {
            var openedScopes = openedDropdowns.map(function (dropdown) {
                return dropdown.scope;
            });
            if (openedScopes.indexOf(dropdownScope) === -1) {
                openedContainers.put(appendTo, {
                    scope: dropdownScope
                });
            }
        } else {
            openedContainers.put(appendTo, {
                scope: dropdownScope
            });
        }
    };

    this.close = function (dropdownScope, element, appendTo) {

        if (openScopes.indexOf(dropdownScope) > -1) {
            var upperScope = getUpperScope();
            while (upperScope) {
                if (upperScope === dropdownScope) {
                    break;
                }
                openScopes.pop().isOpen = false;
                upperScope = getUpperScope();
            }
        }

        if (!getUpperScope()) {
            $document.off('click', closeDropdown);
        }

        if (!appendTo) {
            return;
        }

        var openedDropdowns = openedContainers.get(appendTo);
        if (openedDropdowns) {
            var dropdownToClose = openedDropdowns.reduce(function (toClose, dropdown) {
                if (dropdown.scope === dropdownScope) {
                    return dropdown;
                }

                return toClose;
            }, {});
            if (dropdownToClose) {
                openedContainers.remove(appendTo, dropdownToClose);
            }
        }
    };

    this.keybindFilter = function (evt) {

        var openScope;

        for (var index in openScopes) {
            openScope = openScopes[index];

            var dropdownElement = openScope.getDropdownElement();
            var toggleElement = openScope.getToggleElement();
            var dropdownElementTargeted = dropdownElement && dropdownElement[0].contains(evt.target);
            var toggleElementTargeted = toggleElement && toggleElement[0].contains(evt.target);

            if (evt.which === 27) {
                evt.stopPropagation();
                openScope.focusToggleElement();
                closeDropdown();
            } else if (openScope.isKeynavEnabled() && [38, 40].indexOf(evt.which) !== -1 && openScope.isOpen && (dropdownElementTargeted || toggleElementTargeted)) {
                evt.preventDefault();
                evt.stopPropagation();
                openScope.focusDropdownEntry(evt.which);
            }
        }
    };

    function closeDropdown(evt) {
        var upperScope = getUpperScope();

        while (upperScope) {

            if (!upperScope) {
                break;
            }

            if (evt && upperScope.getAutoClose() === 'disabled') {
                break;
            }

            var toggleElement = upperScope.getToggleElement();
            if (evt && toggleElement && toggleElement[0].contains(evt.target)) {
                break;
            }

            var dropdownElement = upperScope.getDropdownElement();
            if (evt && upperScope.getAutoClose() === 'outsideClick' && dropdownElement && dropdownElement[0].contains(evt.target)) {
                break;
            }

            upperScope.isOpen = false;
            upperScope.focusToggleElement();

            openScopes.pop();

            if (!$rootScope.$$phase) {
                upperScope.$apply();
            }

            if (angular.isUndefined(evt)) {
                break;
            }

            upperScope = getUpperScope();
        }
    }
}]);
'use strict';
angular.module('ng-komondor').directive('dropdownSelect', function () {
    function arrayToObject(options) {
        if (Array.isArray(options)) {
            var obj = {};
            options.forEach(function (value) {
                obj[value] = value;
            });
            return obj;
        }
        return options;
    }
    return {
        restrict: 'AE',
        scope: { options: '=' },
        require: ['ngModel', 'uibDropdown'],
        link: function link($scope, elem, attr, controllers) {
            var NgModelCtrl = controllers[0];
            $scope.optionsObj = arrayToObject($scope.options);
            $scope.model = NgModelCtrl;
            $scope.modelChange = function (value) {
                NgModelCtrl.$setViewValue(value);
            };
            $scope.$watch('options', function () {
                $scope.optionsObj = arrayToObject($scope.options);
            });
            $scope.noCaret = attr.noCaret;
        },
        template: '<button uib-dropdown-toggle class="btn btn-default">' + '{{ optionsObj[model.$modelValue] }}&nbsp' + '<span class="caret" ng-if="!noCaret"></span>' + '</button>' + '<ul class="dropdown-menu">' + '<li class="dropdown-item" ng-repeat="(key, value) in optionsObj">' + '<button class="btn btn-default btn-block" ng-click="modelChange(key)">{{ value }}</button>' + '</li>' + '</ul>'
    };
});
'use strict';
angular.module('ng-komondor').provider('basicHttpInterceptor', function () {
    var settings = this.settings = {
        loadingDelay: 1000,
        loadingProperty: 'loading',
        errorEvents: [{
                    name: 'kd:validation',
                    check: function check(rejection) {
                        return rejection.status === 400 && rejection.data.validation;
                    },
                    get: function get(rejection) {
                        return rejection.data.validation;
                    }
                }, {
                    name: 'kd:validation',
                    check: function check(rejection) {
                        return rejection.status === 422;
                    },
                    get: function get(rejection) {
                        return rejection.data;
                    }
                }, {
                    name: 'kd:404',
                    check: function check(rejection) {
                        return rejection.status === 404;
                    },
                    get: function get(rejection) {
                        return rejection.config;
                    }
                }, {
                    name: 'kd:csrf-mismatch',
                    check: function check(rejection) {
                        return rejection.status === 403 && rejection.data === 'CSRF token mismatch.';
                    },
                    get: function get(rejection) {
                        return rejection.data;
                    }
                }, {
                    name: 'kd:403',
                    check: function check(rejection) {
                        return rejection.status === 403;
                    },
                    get: function get(rejection) {
                        return rejection.data;
                    }
                }, {
                    name: 'kd:alert',
                    check: function check(rejection) {
                        return rejection.status === 400 && rejection.data.alert;
                    },
                    get: function get(rejection) {
                        return rejection.data.alert;
                    }
                }],
        errorCatch: {
            name: 'kd:alert',
            get: function get() {
                return 'Something went wrong';
            }
        }
    };
    this.setLoadingDelay = function (ms) {
        settings.loadingDelay = parseInt(ms);
        if (settings.loadingDelay < 0) {
            settings.loadingDelay = 0;
        }
    };
    this.$get = ["$rootScope", "$timeout", "$q", function ($rootScope, $timeout, $q) {
        var pending = 0;
        var isLoading = false;
        var broadcast = function broadcast(e, rejection) {
            var data = e.get(rejection);
            $rootScope.$broadcast(e.name, data);
        };
        var loading = function loading(bool) {
            if (!bool) {
                $rootScope.$broadcast('loading:stop');
                return;
            }
            if (!isLoading) {
                $rootScope.$broadcast('loading:start');
                $timeout(function () {
                    if (pending > 0) {
                        $rootScope.$broadcast('loading:display');
                    }
                }, settings.loadingDelay);
            }
        };
        var interceptor = {
            // On request success
            request: function request(config) {
                if (!config.quietMode) {
                    pending++;
                    loading(true);
                }
                // Return the config or wrap it in a promise if blank.
                return config || $q.when(config);    // jshint ignore:line
            },
            // On response success
            response: function response(_response) {
                if (!_response.config.quietMode && --pending === 0) {
                    loading(false);
                }
                // Return the response or promise.
                return _response || $q.when(_response);    // jshint ignore:line
            },
            // On response failure
            responseError: function responseError(rejection) {
                if (--pending === 0) {
                    loading(false);
                }
                var e;
                for (var i = 0; i < settings.errorEvents.length; i++) {
                    e = settings.errorEvents[i];
                    if (e.check(rejection)) {
                        broadcast(e, rejection);
                        return $q.reject(rejection);
                    }
                }
                broadcast(settings.errorCatch, rejection);
                return $q.reject(rejection);
            }
        };
        return interceptor;
    }];
}).config(["$httpProvider", function ($httpProvider) {
    $httpProvider.interceptors.push('basicHttpInterceptor');
}])    /**
 * Always clear validation errors if we change state
 */.run(["$rootScope", function ($rootScope) {
    $rootScope.$on('$stateChangeSuccess', function () {
        $rootScope.$broadcast('kd:validation', {});
    });
}])    /**
 * Show a modal to tell the user if their CSRF token has expired.
 */.run(["$rootScope", "notify", "$window", function ($rootScope, notify, $window) {
    $rootScope.$on('kd:csrf-mismatch', function () {
        notify.open({
            title: 'CSRF Token Mismatch',
            message: 'Your security token has expired due to inactivity, please refresh to page to obtain a valid token.'
        }, {
            refresh: {
                label: 'Refresh',
                buttonClass: 'btn btn-primary',
                act: function act() {
                    $window.location.reload();
                }
            },
            cancel: {
                label: 'Cancel',
                buttonClass: 'btn btn-default',
                act: function act(modalInstance) {
                    modalInstance.dismiss();
                }
            }
        });
    });
}]);
'use strict';
angular.module('ng-komondor').directive('formGroup', function () {
    return {
        restrict: 'A',
        transclude: true,
        replace: true,
        scope: { name: '@formGroup' },
        template: '<div class="form-group" ng-class="classes">' + '<div ng-transclude></div>' + '<span class="help-block" ng-repeat="msg in messages">{{msg}}</span>' + '</div>',
        controller: ["$scope", function controller($scope) {
            $scope.classes = {};
            $scope.messages = [];
            var names = $scope.name.split(',');
            $scope.$on('kd:validation', function ($event, messages) {
                $scope.classes = {};
                $scope.messages = [];
                for (var i in names) {
                    var msgs = messages[names[i]];
                    if (msgs) {
                        $scope.messages = $scope.messages.concat(msgs);
                        $scope.classes['has-error'] = true;
                    }
                }
            });
        }]
    };
});
'use strict';
angular.module('ng-komondor').directive('loadingDisplay', function () {
    return {
        link: function link($scope, element) {
            element.addClass('ng-hide');
            $scope.$on('loading:display', function () {
                element.removeClass('ng-hide');
            });
            $scope.$on('loading:stop', function () {
                element.addClass('ng-hide');
            });
        }
    };
}).directive('loadingDisabled', function () {
    return {
        link: function link($scope, element) {
            $scope.$on('loading:start', function () {
                element.attr('disabled', 'disabled');
            });
            $scope.$on('loading:stop', function () {
                element.removeAttr('disabled');
            });
        }
    };
});
'use strict';
angular.module('ng-komondor').directive('kdDbltap', function () {
    return {
        restrict: 'A',
        bindToController: true,
        scope: { callback: '&kdDbltap' },
        controller: ["$element", "$attrs", "Hammer", function controller($element, $attrs, Hammer) {
            var _this = this;
            var mc = new Hammer.Manager($element[0]);
            mc.add(new Hammer.Tap({
                event: 'dbltap',
                taps: 2
            }));
            mc.on('dbltap', function (event) {
                _this.callback({ $event: event.srcEvent });
            });
        }]
    };
});
'use strict';
angular.module('ng-komondor').provider('kdScroll', function () {
    /**
     * Offset all element scrolls by this amount
     */
    var _offset = 0;
    /**
     * Offset all element scrolls by the height of this element
     */
    var offsetElementId = null;
    /**
     * Offset all element scrolls by this amount
     */
    this.setOffset = function (value) {
        _offset = parseInt(value);
    };
    /**
     * Offset all element scrolls by the height of this element
     */
    this.setOffsetEelement = function (elementId) {
        offsetElementId = elementId;
    };
    this.$get = ["$window", "$log", function ($window, $log) {
        var document = $window.document;
        return {
            /**
             * Get the current vertical scroll position
             */
            getScrollY: function getScrollY() {
                // Firefox, Chrome, Opera, Safari.
                if ($window.pageYOffset) {
                    return $window.pageYOffset;
                }
                // Internet Explorer 6 (standards mode).
                if (document.documentElement && document.documentElement.scrollTop) {
                    return document.documentElement.scrollTop;
                }
                // Internet Explorer 6, 7 and 8.
                if (document.body.scrollTop) {
                    return document.body.scrollTop;
                }
                return 0;
            },
            /**
             * Get an element's top border scroll position
             */
            getElementY: function getElementY(id) {
                return document.getElementById(id).getBoundingClientRect().top;
            },
            /**
             * Get the desired offset based on offset and offsetElementId
             */
            offset: function offset() {
                var element = document.getElementById(offsetElementId);
                if (element) {
                    var rect = element.getBoundingClientRect();
                    if (rect.top) {
                        return rect.height + _offset;
                    }
                }
                return _offset;
            },
            /**
             *
             * @param id The id of the element to scroll to.
             */
            scrollToElementById: function scrollToElementById(id) {
                var element = document.getElementById(id);
                if (!element) {
                    $log.warn('Cannot find element with id [' + id + '].');
                    return;
                }
                var y = this.getScrollY() + this.getElementY(id) - this.offset();
                this.scrollTo(null, y);
            },
            /**
             *
             * @param animate see scrollTo
             */
            scrollToTop: function scrollToTop(animate) {
                this.scrollTo(null, 0, animate);
            },
            /**
             *
             * @param animate Use TweenMax (defaults true)
             */
            scrollTo: function scrollTo(x, y, animate) {
                if (animate === false || !$window.TweenMax) {
                    return $window.scrollTo(x, y);
                }
                $window.TweenMax.to($window, 0.5, {
                    scrollTo: {
                        x: x,
                        y: y
                    },
                    ease: $window.Power2.easeOut
                });
            }
        };
    }];
});
'use strict';
angular.module('ng-komondor').provider('notify', function () {
    var defaultOptions = {
        windowClass: '',
        title: 'Alert',
        message: '',
        prompt: false,
        inputClass: null
    };
    var defaultActions = {
        ok: {
            label: 'OK',
            buttonClass: 'btn btn-primary btn-block',
            act: function act(modalInstance, result) {
                modalInstance.close(result);
            }
        }
    };
    var cancelAction = {
        cancel: {
            label: 'Cancel',
            buttonClass: 'btn btn-default btn-block',
            act: function act(modalInstance) {
                modalInstance.dismiss();
            }
        }
    };
    var confirmOptions = { title: 'Confirm' };
    var promptOptions = {
        title: 'Prompt',
        prompt: true,
        inputClass: null
    };
    var confirmActions = angular.extend({}, defaultActions, cancelAction);
    var promptActions = angular.extend({}, defaultActions, cancelAction);
    // Helper function to define column classes
    // for footer button actions accordingly
    var actionClassHelper = function actionClassHelper(actions) {
        var actionsLength = Object.keys(actions).length;
        return actionsLength === 1 ? 'col-xs-6 col-xs-offset-6' : 'col-xs-' + 12 / actionsLength;
    };
    this.$get = ["$uibModal", function ($uibModal) {
        return {
            open: function open(_options, _actions) {
                _actions = typeof _actions !== 'undefined' ? _actions : defaultActions;
                return $uibModal.open({
                    windowClass: _options.windowClass,
                    templateUrl: 'ng-komondor/notify/notify.html',
                    controller: ['$scope', '$uibModalInstance', 'options', 'actions', function ($scope, $uibModalInstance, options, actions) {
                                            $scope.options = options;
                                            $scope.actions = actions;
                                            $scope.result = {
                                                value: options.value
                                            };
                    
                                            $scope.actionColumnClass = actionClassHelper(actions);
                    
                                            $scope.cancel = function () {
                                                $uibModalInstance.dismiss('close');
                                            };
                    
                                            $scope.act = function (action) {
                                                return action.act($uibModalInstance, $scope.result.value, options);
                                            };
                                        }],
                    resolve: {
                        options: function options() {
                            return _options;
                        },
                        actions: function actions() {
                            return _actions;
                        }
                    }
                });
            },
            alert: function alert(message, options) {
                options = typeof options !== 'undefined' ? options : {};
                options = angular.extend({}, defaultOptions, options);
                options.message = message;
                return this.open(options);
            },
            confirm: function confirm(message, options) {
                options = typeof options !== 'undefined' ? options : {};
                options = angular.extend({}, confirmOptions, options);
                options.message = message;
                return this.open(options, confirmActions);
            },
            prompt: function prompt(message, options) {
                options = typeof options !== 'undefined' ? options : {};
                options = angular.extend({}, promptOptions, options);
                options.message = message;
                return this.open(options, promptActions);
            }
        };
    }];
});
'use strict';
angular.module('ng-komondor').directive('picture', ["$window", "debounce", function ($window, debounce) {
    function link(scope, element) {
        scope.clipper = element.children()[0];
        var image = angular.element(scope.clipper).children()[0];
        image.onload = function () {
            var imageHeight = image.naturalHeight || image.height;
            var imageWidth = image.naturalWidth || image.width;
            var imageRatio = imageWidth / imageHeight;
            var aspectRatio = scope.clipper.offsetWidth / scope.clipper.offsetHeight;
            if (imageRatio > aspectRatio) {
                angular.element(image).addClass('fit-height');
            } else {
                angular.element(image).removeClass('fit-height');
            }
        };
        var debounced = debounce(image.onload, 250);
        angular.element($window).on('resize', debounced);
        scope.$watchGroup(['clipper.clientWidth', 'clipper.clientHeight'], function () {
            image.onload();
        });
        scope.$on('$destroy', function () {
            angular.element($window).off('resize', debounced);
        });
    }
    return {
        scope: { src: '=picture' },
        link: link,
        template: '<div class="clipper">' + '<img ng-src="{{src}}"  />' + '</div>'
    };
}]);
'use strict';
angular.module('ng-komondor').provider('styleGuide', function () {
    var list = [{
            label: 'Typography',
            templateUrl: 'ng-komondor/style-guide/typography.html'
        }, {
            label: 'Icons',
            templateUrl: 'ng-komondor/style-guide/icons.html'
        }, {
            label: 'Themes',
            templateUrl: 'ng-komondor/style-guide/theme-guide.html'
        }, {
            label: 'Buttons',
            templateUrl: 'ng-komondor/style-guide/buttons.html'
        }, {
            label: 'Canvas Image',
            templateUrl: 'ng-komondor/style-guide/canvas-image.html'
        }];
    this.push = function (guide) {
        list.push(guide);
    };
    this.$get = function () {
        return { list: list };
    };
});
'use strict';
angular.module('ng-komondor').factory('createTree', function () {
    function createTree(list, options) {
        var top = [], indexedTree = {};
        var defaultOptions = {
            foreignKey: 'parent_id',
            idProp: 'id'
        };
        // Allow override of default options
        options = angular.extend(defaultOptions, options);
        // Wrap each item in a treeish
        angular.forEach(list, function (item) {
            indexedTree[item[options.idProp]] = {
                parent: null,
                children: [],
                model: item
            };
        });
        // Add each item to its parent's children property array
        // And set its parent property for circular reference
        angular.forEach(list, function (item) {
            // If it has a parent key, find the parent
            var treeish = indexedTree[item[options.idProp]];
            if (item[options.foreignKey]) {
                treeish.parent = indexedTree[item[options.foreignKey]];
                // If the parent was found, add this item as a child
                if (treeish.parent) {
                    treeish.parent.children.push(treeish);
                }
            }    // Otherwise add it to the top array
            else {
                top.push(treeish);
            }
        });
        // Return the top array
        return top;
    }
    return createTree;
});
'use strict';
angular.module('ng-komondor').factory('traverseTree', function () {
    var defaultOptions = {
        children: 'children',
        callback: null,
        revserseCallback: null
    };
    function traverseTree(tree, options) {
        if (options.callback) {
            options.callback(tree, options);
        }
        for (var i = 0; i < tree.children.length; i++) {
            traverseTree(tree.children[i], options);
        }
        if (options.revserseCallback) {
            options.revserseCallback(tree, options);
        }
    }
    function startTraverseTree(tree, options) {
        options = angular.extend(defaultOptions, options);
        traverseTree(tree, options);
    }
    return startTraverseTree;
});
'use strict';
angular.module('ng-komondor').directive('treeish', ["recursionHelper", function (recursionHelper) {
    return {
        restrict: 'A',
        replace: true,
        scope: {
            treeish: '=',
            options: '='
        },
        controller: ["$scope", function controller($scope) {
            $scope.model = $scope.treeish.model;
            $scope.toggle = function () {
                $scope.treeish.open = !$scope.treeish.open;
            };
        }],
        template: '<div ng-class="{open: treeish.open}">' + '<div ng-include="options.templateUrl"></div>' + '<div class="children">' + '<div treeish="child" options="options" ng-repeat="child in treeish.children"></div>' + '</div>' + '</div>',
        compile: function compile(element) {
            // Use the compile function from the RecursionHelper,
            // And return the linking function(s) which it returns
            return recursionHelper.compile(element);
        }
    };
}]);
'use strict';
angular.module('ng-komondor').filter('bytes', function () {
    return function (bytes) {
        if (!bytes) {
            return;
        }
        var thresh = 1024;
        if (bytes < thresh) {
            return bytes + ' B';
        }
        var units = ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
        var u = -1;
        do {
            bytes /= thresh;
            ++u;
        } while (bytes >= thresh);
        return bytes.toFixed(1) + ' ' + units[u];
    };
});
'use strict';
angular.module('ng-komondor')    /**
 * taken from https://remysharp.com/2010/07/21/throttling-function-calls
 * with modifications
 */.factory('debounce', ["$timeout", function ($timeout) {
    return function debounce(fn, delay, options) {
        var timer = null;
        options = angular.extend({ context: null }, options);
        return function () {
            var context = options.context || this;
            var args = arguments;
            if (timer) {
                $timeout.cancel(timer);
            }
            timer = $timeout(function () {
                fn.apply(context, args);
            }, delay);
        };
    };
}]);
'use strict';
angular.module('ng-komondor').factory('extendDeep', function () {
    function extendDeep(dst) {
        angular.forEach(arguments, function (obj) {
            if (obj !== dst) {
                angular.forEach(obj, function (value, key) {
                    if (value && value.constructor && value.constructor === Object) {
                        if (!dst[key]) {
                            dst[key] = {};
                        }
                        extendDeep(dst[key], value);
                    } else {
                        dst[key] = value;
                    }
                });
            }
        });
        return dst;
    }
    return extendDeep;
});
'use strict';
angular.module('ng-komondor').factory('fabric', ["$window", function ($window) {
    return $window.fabric;
}]);
'use strict';
angular.module('ng-komondor').directive('focusMe', ["$timeout", "$parse", function ($timeout, $parse) {
    return {
        link: function link($scope, element, attrs) {
            var model = $parse(attrs.focusMe);
            $scope.$watch(model, function (value) {
                if (value === true) {
                    $timeout(function () {
                        element[0].focus();
                    });
                }
            });
            element.bind('focus', function () {
                $scope.$evalAsync(function () {
                    $scope.$emit('component:focus');
                });
            });
            element.bind('blur', function () {
                $scope.$evalAsync(function () {
                    model.assign($scope, false);
                });
            });
        }
    };
}]);
'use strict';
angular.module('ng-komondor').factory('Hammer', ["$window", function ($window) {
    return $window.Hammer;
}]);
'use strict';
angular.module('ng-komondor').factory('indexList', function () {
    function indexList(list, key, callback) {
        var indexed = {};
        var i, item;
        for (i = 0; i < list.length; i++) {
            item = list[i];
            if (callback) {
                callback(item);
            }
            indexed[item[key]] = item;
        }
        return indexed;
    }
    return indexList;
});
'use strict';
angular.module('ng-komondor').factory('localStorageValid', ["$window", function ($window) {
    return function localStorageValid() {
        try {
            return typeof $window.localStorage !== 'undefined' && 'setItem' in $window.localStorage && $window.localStorage.setItem;
        } catch (e) {
            return false;
        }
    };
}]);
'use strict';
angular.module('ng-komondor').provider('modalState', ["$stateProvider", function ($stateProvider) {
    var defaultOptions = {
        reloadOnExit: true,
        parentResolves: []
    };
    var modalState = {
        stateParams: {},
        parentResolves: {}
    };
    this.$get = function () {
        return modalState;
    };
    this.state = function (stateName, options) {
        var modalInstance;
        options = angular.extend({}, defaultOptions, options);
        var open = function open($uibModal, $state, $stateParams) {
            var resolved = Array.prototype.slice.call(arguments, 3);
            // Add the resolved objects for options.parentResolves = ['injectable']
            // onto modalState.parentResolves = {injectable: resolvedObject}
            modalState.parentResolves = {};
            angular.forEach(resolved, function (item, idx) {
                modalState.parentResolves[options.parentResolves[idx]] = item;
            });
            // Store state params on the modalState so they can be accessed in modal resolves
            // because state.onEnter gets the previous state params
            modalState.stateParams = $stateParams;
            modalInstance = $uibModal.open(options);
            // Add a hook so things can be reverted if the modal is dismissed
            if (options.onDismiss) {
                modalInstance.result.catch(function () {
                    options.onDismiss(modalState);
                });
            }
            // Go to the parent state if resolved
            modalInstance.result.finally(function () {
                modalInstance = null;
                if ($state.$current.name === stateName) {
                    $state.go('^', {}, { reload: options.reloadOnExit });
                }
            });
        };
        var injectedOpen = ['$uibModal', '$state', '$stateParams'].concat(options.parentResolves);
        injectedOpen.push(open);
        $stateProvider.state(stateName, {
            url: options.url,
            onEnter: injectedOpen,
            onExit: [function () {
                            if (modalInstance) {
                                modalInstance.close();
                            }
                        }]
        });
    };
}]);
'use strict';
angular.module('ng-komondor').factory('objectDefaults', function () {
    function objectDefaults(dst, defaults) {
        angular.forEach(defaults, function (value, key) {
            if (angular.isUndefined(dst[key])) {
                dst[key] = angular.copy(defaults[key]);
            } else if (angular.isObject(dst[key])) {
                if (!angular.isObject(defaults[key])) {
                    throw 'The destination object doesn\'t match the default.';
                }
                objectDefaults(value, defaults[key]);
            }
        });
        return dst;
    }
    return objectDefaults;
});
'use strict';
angular.module('ng-komondor')    /**
 * @memberOf komondor.util
 * @ngdoc service
 * @name recursionHelper
 * @description
 * Use to compile recursive directives
 *
 * ```
 * angular.module('my-module').directive('my-directive', function() {
 *   return {
 *     compile: function (element) {
 *       return recursionHelper.compile(element);
 *     }
 *   };
 * });
 * ```
 */.factory('recursionHelper', ["$compile", function ($compile) {
    return {
        compile: function compile(element, link) {
            // Normalize the link parameter
            if (angular.isFunction(link)) {
                link = { post: link };
            }
            // Break the recursion loop by removing the contents
            var contents = element.contents().remove();
            var compiledContents;
            return {
                pre: link && link.pre ? link.pre : null,
                // Compiles and re-adds the contents
                post: function post(scope, element) {
                    // Compile the contents
                    if (!compiledContents) {
                        compiledContents = $compile(contents);
                    }
                    // Re-add the compiled contents to the element
                    compiledContents(scope, function (clone) {
                        element.append(clone);
                    });
                    // Call the post-linking function, if any
                    if (link && link.post) {
                        link.post.apply(null, arguments);
                    }
                }
            };
        }
    };
}]);
'use strict';
angular.module('ng-komondor').directive('stateClassifier', function () {
    return {
        bindToController: true,
        controllerAs: 'stateClassifier',
        controller: ["$scope", "$element", "$state", function controller($scope, $element, $state) {
            var _this = this;
            this.classify = function (toState, fromState) {
                var list = void 0;
                var parts = void 0;
                if (fromState && fromState.name !== '') {
                    parts = fromState.name.split('.');
                    list = [];
                    angular.forEach(parts, function (part) {
                        list.push(part);
                        $element.removeClass(list.join('-'));
                    });
                }
                parts = toState.name.split('.');
                list = [];
                angular.forEach(parts, function (part) {
                    list.push(part);
                    $element.addClass(list.join('-'));
                });
            };
            this.$onInit = function () {
                this.classify($state.current, null);
            };
            $scope.$on('$stateChangeSuccess', function ($event, toState, toParams, fromState) {
                _this.classify(toState, fromState);
            });
        }]
    };
});
'use strict';
angular.module('ng-komondor').directive('sticky', ["$timeout", "$window", "$document", "debounce", function ($timeout, $window, $document, debounce) {
    var win = $window;
    $window = angular.element($window);
    var link = function link($scope, elem, attrs) {
        // Required when resource-view is opened in a modal,
        // can you think of a better way?
        if ($scope.$parent) {
            if (typeof $scope.$parent.$close === 'function' && typeof $scope.$parent.$dismiss === 'function') {
                return;
            }
        }
        $timeout(function () {
            $timeout(function () {
                var offsetTop = $scope.offSet || 0, doc = $document[0].documentElement, params, stickyLine, placeholder;
                function setInitial() {
                    if (!placeholder) {
                        createPlaceholder();
                    }
                    params = getParams();
                    stickyLine = findOffsetTop(elem[0]) - offsetTop;
                    checkSticky();
                }
                function getMargin() {
                    var style = win.getComputedStyle(elem[0]);
                    return [style.marginTop, style.marginRight, style.marginBottom, style.marginLeft].join(' ');
                }
                function findOffsetTop(obj) {
                    var curtop = 0;
                    do {
                        curtop += obj.offsetTop;
                        obj = obj.offsetParent;
                    } while (obj !== null && obj !== obj.offsetParent);
                    return curtop;
                }
                function getParams() {
                    var boundRect = elem[0].getBoundingClientRect();
                    return {
                        margin: getMargin(),
                        top: elem.css('top'),
                        position: elem.css('position'),
                        height: boundRect.height,
                        width: boundRect.width
                    };
                }
                function checkSticky() {
                    var scrollTop = ($document[0].body.scrollTop || doc.scrollTop) - (doc.clientTop || 0);
                    if (scrollTop > stickyLine) {
                        placeholder.css({
                            width: params.width + 'px',
                            height: params.height + 'px',
                            margin: params.margin,
                            display: 'block',
                            overflow: 'hidden'
                        });
                        elem.css({
                            position: 'fixed',
                            display: 'block',
                            top: offsetTop + 'px',
                            left: elem[0].getBoundingClientRect().left + 'px',
                            height: params.height + 'px',
                            width: params.width + 'px',
                            margin: 0,
                            'z-index': attrs.zIndex || '9999'
                        });
                    } else {
                        placeholder.css({ display: 'none' });
                        elem.removeAttr('style');
                    }
                }
                function createPlaceholder() {
                    placeholder = angular.element('<div/>');
                    elem[0].parentNode.insertBefore(placeholder[0], elem[0].nextSibling);
                }
                var resize = debounce(function () {
                    elem.attr('style', '');
                    $timeout(setInitial);
                }, 250);
                var cleanUp = function cleanUp() {
                    $window.off('scroll', checkSticky);
                    $window.off('resize', resize);
                };
                $window.on('scroll', checkSticky);
                $window.on('resize', resize);
                $scope.$on('$destroy', cleanUp);
                setInitial();
            });
        });
    };
    return {
        restrict: 'A',
        scope: { offSet: '=?' },
        link: link
    };
}]);
'use strict';
angular.module('ng-komondor')    /**
 * taken from https://remysharp.com/2010/07/21/throttling-function-calls
 * with modifications
 */.factory('throttle', ["$timeout", function ($timeout) {
    return function throttle(fn, threshhold, options) {
        threshhold = threshhold || 250;
        var last;
        var args;
        var timer;
        options = angular.extend({ context: null }, options);
        return function () {
            args = arguments;
            if (timer) {
                return;
            }
            var now = new Date();
            var timeElapsed = now - last;
            var context = options.context || this;
            if (!last || timeElapsed > threshhold) {
                last = now;
                fn.apply(context, args);
            } else {
                timer = $timeout(function () {
                    timer = null;
                    fn.apply(context, args);
                }, threshhold - timeElapsed);
            }
        };
    };
}]);
'use strict';
// https://gist.github.com/jeffjohnson9046/9789876
angular.module('ng-komondor').filter('titleCase', function () {
    return function (input) {
        var smallWords = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|vs?\.?|via)$/i;
        input = input.toLowerCase();
        return input.replace(/[A-Za-z0-9\u00C0-\u00FF]+[^\s-]*/g, function (match, index, title) {
            if (index > 0 && index + match.length !== title.length && match.search(smallWords) > -1 && title.charAt(index - 2) !== ':' && (title.charAt(index + match.length) !== '-' || title.charAt(index - 1) === '-') && title.charAt(index - 1).search(/[^\s-]/) < 0) {
                return match.toLowerCase();
            }
            if (match.substr(1).search(/[A-Z]|\../) > -1) {
                return match;
            }
            return match.charAt(0).toUpperCase() + match.substr(1);
        });
    };
});
'use strict';
angular.module('ng-komondor').factory('zeroWidthSpaceCleaner', function () {
    var regex = /[\u200B-\u200D\uFEFF]/g;
    return {
        match: function match(string) {
            return string.match(regex);
        },
        remove: function remove(string) {
            return string.replace(regex, '');
        }
    };
});
'use strict';
angular.module('ng-komondor.templates', []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("ng-komondor/canvas-image/canvas-image.html", "<canvas id=\"image-canvas\"></canvas><div id=\"overlay\" class=\"btn-group-vertical hidden-xs\" role=\"group\"><button type=\"button\" class=\"btn btn-default\" ng-mousedown=\"$ctrl.reset()\"><span class=\"glyphicon glyphicon-refresh\"></span></button><button type=\"button\" class=\"btn btn-default\" ng-mousedown=\"$ctrl.scaleRelative(0.1)\"><span class=\"glyphicon glyphicon-plus-sign\"></span></button><button type=\"button\" class=\"btn btn-default\" ng-mousedown=\"$ctrl.scaleRelative(-0.1)\"><span class=\"glyphicon glyphicon-minus-sign\"></span></button></div>");
  $templateCache.put("ng-komondor/checkbox-input/checkbox.input.html", "<input id=\"checkbox-input-{{$id}}\" type=\"checkbox\" ng-change=\"$ctrl.updateNgModel($ctrl.ngModel)\" ng-disabled=\"$ctrl.disabled\" ng-true-value=\"{{ $ctrl.trueValue }}\" ng-false-value=\"{{ $ctrl.falseValue }}\" ng-model=\"$ctrl.ngModel\"><label for=\"checkbox-input-{{$id}}\">{{ $ctrl.label }}</label>");
  $templateCache.put("ng-komondor/notify/notify.html", "<div class=\"modal-header text-center\"><button type=\"button\" class=\"close\" ng-click=\"$dismiss()\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button><h1 class=\"modal-title\">{{ options.title }}</h1></div><div class=\"modal-body text-center\"><p>{{ options.message }}</p><div ng-if=\"options.prompt\"><input type=\"text\" class=\"form-control\" ng-class=\"options.inputClass\" ng-model=\"result.value\"></div></div><div class=\"modal-footer\"><div class=\"row\"><div ng-class=\"actionColumnClass\" ng-repeat=\"action in actions\"><button type=\"button\" ng-class=\"action.buttonClass\" ng-click=\"act(action)\">{{ action.label }}</button></div></div></div>");
  $templateCache.put("ng-komondor/style-guide/buttons.html", "<div class=\"container\"><h1 id=\"button\">Buttons</h1><p><button class=\"btn btn-default\">Anchor Button</button><button class=\"btn btn-default\">Button Element</button><input class=\"btn btn-danger\" type=\"reset\" value=\"Danger\"> <input class=\"btn btn-primary\" type=\"submit\" value=\"Primary\"></p><h1 id=\"button-group\">Button Group</h1><div class=\"btn-group\"><a class=\"btn btn-default\">Anchor</a><button class=\"btn btn-default\">Button</button></div><h1 id=\"button-toolbar\">Button Toolbar</h1><div class=\"btn-toolbar\"><div class=\"btn-group\"><a class=\"btn btn-default\">Anchor</a><button class=\"btn btn-default\">Button</button></div><div class=\"btn-group\"><a class=\"btn btn-primary\">Anchor</a><button class=\"btn btn-primary\">Button</button></div></div><h1 id=\"radio-buttons\">Radio Buttons</h1><div class=\"btn-group btn-group-justified\" ng-init=\"model.radio = \'two\'\"><a ng-model=\"model.radio\" uib-btn-radio=\"\'one\'\" class=\"btn btn-default\">One</a><a ng-model=\"model.radio\" uib-btn-radio=\"\'two\'\" class=\"btn btn-default\">Two</a><a ng-model=\"model.radio\" uib-btn-radio=\"\'three\'\" class=\"btn btn-default\">Three</a></div><hr></div>");
  $templateCache.put("ng-komondor/style-guide/canvas-image.html", "<h3>Description</h3><p>This directive allows the user to zoom and pan around an image.</p><h3>Examples</h3><code style=\"white-space: pre-line;\">&#x3C;canvas-image source=&#x22;http://www.petpaw.com.au/wp-content/uploads/2014/06/Komondor-5.jpg&#x22;&#x3E;&#x3C;/canvas-image&#x3E;</code><h3>Demo</h3><canvas-image source=\"http://www.petpaw.com.au/wp-content/uploads/2014/06/Komondor-5.jpg\"></canvas-image>");
  $templateCache.put("ng-komondor/style-guide/icons.html", "<style type=\"text/css\">.example-komondor-icons {\n        margin-top: 20px;\n    }\n\n    .example-komondor-icons li {\n        float: left;\n        height: 115px;\n        width: 115px;\n        padding: 10px 5px;\n    }\n\n    .example-komondor-icons i {\n        font-size: 24px;\n        display: block;\n        text-align: center;\n    }\n\n    .example-komondor-icons span {\n        display: block;\n        text-align: center;\n    }</style><ul class=\"example-komondor-icons list-unstyled row\"><li><i class=\"kd-icon kd-icon-bold\"></i><span>kd-icon kd-icon-bold</span></li><li><i class=\"kd-icon kd-icon-italic\"></i><span>kd-icon kd-icon-italic</span></li><li><i class=\"kd-icon kd-icon-underline\"></i><span>kd-icon kd-icon-underline</span></li><li><i class=\"kd-icon kd-icon-h1\"></i><span>kd-icon kd-icon-h1</span></li><li><i class=\"kd-icon kd-icon-subscript\"></i><span>kd-icon kd-icon-subscript</span></li><li><i class=\"kd-icon kd-icon-superscript\"></i><span>kd-icon kd-icon-superscript</span></li><li><i class=\"kd-icon kd-icon-link\"></i><span>kd-icon kd-icon-link</span></li><li><i class=\"kd-icon kd-icon-unlink\"></i><span>kd-icon kd-icon-unlink</span></li><li><i class=\"kd-icon kd-icon-four-column\"></i><span>kd-icon kd-icon-four-column</span></li><li><i class=\"kd-icon kd-icon-one-column\"></i><span>kd-icon kd-icon-one-column</span></li><li><i class=\"kd-icon kd-icon-three-column\"></i><span>kd-icon kd-icon-three-column</span></li><li><i class=\"kd-icon kd-icon-two-column\"></i><span>kd-icon kd-icon-two-column</span></li><li><i class=\"kd-icon kd-icon-clear\"></i><span>kd-icon kd-icon-clear</span></li><li><i class=\"kd-icon kd-icon-position-center\"></i><span>kd-icon kd-icon-position-center</span></li><li><i class=\"kd-icon kd-icon-position-left\"></i><span>kd-icon kd-icon-position-left</span></li><li><i class=\"kd-icon kd-icon-position-right\"></i><span>kd-icon kd-icon-position-right</span></li><li><i class=\"kd-icon kd-icon-position-top\"></i><span>kd-icon kd-icon-position-top</span></li><li><i class=\"kd-icon kd-icon-position-bottom\"></i><span>kd-icon kd-icon-position-bottom</span></li><li><i class=\"kd-icon kd-icon-align-center\"></i><span>kd-icon kd-icon-align-center</span></li><li><i class=\"kd-icon kd-icon-align-justified\"></i><span>kd-icon kd-icon-align-justified</span></li><li><i class=\"kd-icon kd-icon-align-left\"></i><span>kd-icon kd-icon-align-left</span></li><li><i class=\"kd-icon kd-icon-align-right\"></i><span>kd-icon kd-icon-align-right</span></li><li><i class=\"kd-icon kd-icon-arrow-up\"></i><span>kd-icon kd-icon-arrow-up</span></li><li><i class=\"kd-icon kd-icon-arrow-down\"></i><span>kd-icon kd-icon-arrow-down</span></li><li><i class=\"kd-icon kd-icon-arrow-left\"></i><span>kd-icon kd-icon-arrow-left</span></li><li><i class=\"kd-icon kd-icon-arrowhead-right\"></i><span>kd-icon kd-icon-arrowhead-right</span></li><li><i class=\"kd-icon kd-icon-tick\"></i><span>kd-icon kd-icon-tick</span></li><li><i class=\"kd-icon kd-icon-play\"></i><span>kd-icon kd-icon-play</span></li><li><i class=\"kd-icon kd-icon-pause\"></i><span>kd-icon kd-icon-pause</span></li><li><i class=\"kd-icon kd-icon-volume-on\"></i><span>kd-icon kd-icon-volume-on</span></li><li><i class=\"kd-icon kd-icon-volume-off\"></i><span>kd-icon kd-icon-volume-off</span></li><li><i class=\"kd-icon kd-icon-expand\"></i><span>kd-icon kd-icon-expand</span></li><li><i class=\"kd-icon kd-icon-shrink\"></i><span>kd-icon kd-icon-shrink</span></li><li><i class=\"kd-icon kd-icon-search\"></i><span>kd-icon kd-icon-search</span></li><li><i class=\"kd-icon kd-icon-plus\"></i><span>kd-icon kd-icon-plus</span></li><li><i class=\"kd-icon kd-icon-batch-upload\"></i><span>kd-icon kd-icon-batch-upload</span></li><li><i class=\"kd-icon kd-icon-edit\"></i><span>kd-icon kd-icon-edit</span></li><li><i class=\"kd-icon kd-icon-trash\"></i><span>kd-icon kd-icon-trash</span></li><li><i class=\"kd-icon kd-icon-move\"></i><span>kd-icon kd-icon-move</span></li><li><i class=\"kd-icon kd-icon-view\"></i><span>kd-icon kd-icon-view</span></li><li><i class=\"kd-icon kd-icon-publish\"></i><span>kd-icon kd-icon-publish</span></li><li><i class=\"kd-icon kd-icon-clone\"></i><span>kd-icon kd-icon-clone</span></li><li><i class=\"kd-icon kd-icon-download\"></i><span>kd-icon kd-icon-download</span></li><li><i class=\"kd-icon kd-icon-presentation\"></i><span>kd-icon kd-icon-presentation</span></li><li><i class=\"kd-icon kd-icon-slide\"></i><span>kd-icon kd-icon-slide</span></li><li><i class=\"kd-icon kd-icon-media\"></i><span>kd-icon kd-icon-media</span></li><li><i class=\"kd-icon kd-icon-data\"></i><span>kd-icon kd-icon-data</span></li><li><i class=\"kd-icon kd-icon-user\"></i><span>kd-icon kd-icon-user</span></li><li><i class=\"kd-icon kd-icon-grid\"></i><span>kd-icon kd-icon-grid</span></li><li><i class=\"kd-icon kd-icon-list\"></i><span>kd-icon kd-icon-list</span></li><li><i class=\"kd-icon kd-icon-image-background\"></i><span>kd-icon kd-icon-image-background</span></li><li><i class=\"kd-icon kd-icon-map\"></i><span>kd-icon kd-icon-map</span></li><li><i class=\"kd-icon kd-icon-preview\"></i><span>kd-icon kd-icon-preview</span></li><li><i class=\"kd-icon kd-icon-folder\"></i><span>kd-icon kd-icon-folder</span></li><li><i class=\"kd-icon kd-icon-presentation-small\"></i><span>kd-icon kd-icon-presentation-small</span></li><li><i class=\"kd-icon kd-icon-image-small\"></i><span>kd-icon kd-icon-image-small</span></li><li><i class=\"kd-icon kd-icon-slide-small\"></i><span>kd-icon kd-icon-slide-small</span></li><li><i class=\"kd-icon kd-icon-video-small\"></i><span>kd-icon kd-icon-video-small</span></li><li><i class=\"kd-icon kd-icon-arrowhead-left\"></i><span>kd-icon kd-icon-arrowhead-left</span></li><li><i class=\"kd-icon kd-icon-arrowhead-right\"></i><span>kd-icon kd-icon-arrowhead-right</span></li><li><i class=\"kd-icon kd-icon-arrowhead-up\"></i><span>kd-icon kd-icon-arrowhead-up</span></li><li><i class=\"kd-icon kd-icon-arrowhead-right\"></i><span>kd-icon kd-icon-arrowhead-right</span></li><li><i class=\"kd-icon kd-icon-arrowhead-down\"></i><span>kd-icon kd-icon-arrowhead-down</span></li><li><i class=\"kd-icon kd-icon-arrowhead-right\"></i><span>kd-icon kd-icon-arrowhead-right</span></li><li><i class=\"kd-icon kd-icon-client\"></i><span>kd-icon kd-icon-client</span></li><li><i class=\"kd-icon kd-icon-master\"></i><span>kd-icon kd-icon-master</span></li><li><i class=\"kd-icon kd-icon-template\"></i><span>kd-icon kd-icon-template</span></li><li><i class=\"kd-icon kd-icon-slide\"></i><span>kd-icon kd-icon-slide</span></li><li><i class=\"kd-icon kd-icon-unpublish\"></i><span>kd-icon kd-icon-unpublish</span></li></ul>");
  $templateCache.put("ng-komondor/style-guide/style-guide.html", "<div class=\"container\"><ul class=\"nav nav-tabs\"><li role=\"presentation\" ng-repeat=\"stylePage in styleGuide.list\"><a ui-sref=\"style-guide({styleTab: stylePage.label})\" ui-sref-active>{{ stylePage.label }}</a></li></ul><div ng-if=\"stylePage\"><div ng-if=\"stylePage.controller\" ng-include=\"stylePage.templateUrl\" ng-controller=\"stylePage.controller\"></div><div ng-if=\"!stylePage.controller\" ng-include=\"stylePage.templateUrl\"></div></div></div>");
  $templateCache.put("ng-komondor/style-guide/theme-guide.html", "<div class=\"container\"><h1>Themes</h1><h3>Primary</h3><div class=\"row\"><div class=\"col-xs-4\"><h5>Normal</h5></div><div class=\"col-xs-4\"><h5>Hover<small>(hover & focus)</small></h5></div><div class=\"col-xs-4\"><h5>Active<small>(active & selected)</small></h5></div></div><div class=\"row\"><div class=\"col-xs-4\"><div class=\"themed-primary themed-interactive\"><h5>Normal</h5><span class=\"themed-contrast\">Contrast</span></div></div><div class=\"col-xs-4\"><div class=\"themed-primary themed-interactive focus\"><h5>Hover</h5><span class=\"themed-contrast\">Contrast</span></div></div><div class=\"col-xs-4\"><div class=\"themed-primary themed-interactive active\"><h5>Active</h5><span class=\"themed-contrast\">Contrast</span></div></div></div><h3>Neutral</h3><div class=\"row\"><div class=\"col-xs-4\"><div class=\"themed-neutral themed-interactive\"><h5>Normal</h5><span class=\"themed-contrast\">Contrast</span></div></div><div class=\"col-xs-4\"><div class=\"themed-neutral themed-interactive focus\"><h5>Hover</h5><span class=\"themed-contrast\">Contrast</span></div></div><div class=\"col-xs-4\"><div class=\"themed-neutral themed-interactive active\"><h5>Active</h5><span class=\"themed-contrast\">Contrast</span></div></div></div><h3>Neutral Dark</h3><div class=\"row\"><div class=\"col-xs-4\"><div class=\"themed-neutral-dark themed-interactive\"><h5>Normal</h5><span class=\"themed-contrast\">Contrast</span></div></div><div class=\"col-xs-4\"><div class=\"themed-neutral-dark themed-interactive focus\"><h5>Hover</h5><span class=\"themed-contrast\">Contrast</span></div></div><div class=\"col-xs-4\"><div class=\"themed-neutral-dark themed-interactive active\"><h5>Active</h5><span class=\"themed-contrast\">Contrast</span></div></div></div><h3>Neutral Darker</h3><div class=\"row\"><div class=\"col-xs-4\"><div class=\"themed-neutral-darker themed-interactive\"><h5>Normal</h5><span class=\"themed-contrast\">Contrast</span></div></div><div class=\"col-xs-4\"><div class=\"themed-neutral-darker themed-interactive focus\"><h5>Hover</h5><span class=\"themed-contrast\">Contrast</span></div></div><div class=\"col-xs-4\"><div class=\"themed-neutral-darker themed-interactive active\"><h5>Active</h5><span class=\"themed-contrast\">Contrast</span></div></div></div></div>");
  $templateCache.put("ng-komondor/style-guide/typography.html", "<div class=\"container\"><hr><h1 id=\"headings\">Headings</h1><hr><h1>Heading 1</h1><h2>Heading 2</h2><h3>Heading 3</h3><h4>Heading 4</h4><h5>Heading 5</h5><h6>Heading 6</h6><hr><h1 id=\"headings-with-text\">Headings with Text</h1><hr><h1>Heading 1</h1><p>Lorem ipsum dolor sit amet, adipiscing elit. Nullam dignissim convallis est. Quisque aliquam. Donec faucibus. Nunc iaculis suscipit dui. Nam sit amet sem. Aliquam libero nisi, imperdiet at, tincidunt nec, gravida vehicula, nisl.</p><h2>Heading 2</h2><p>Lorem ipsum dolor sit amet, adipiscing elit. Nullam dignissim convallis est. Quisque aliquam. Donec faucibus. Nunc iaculis suscipit dui. Nam sit amet sem. Aliquam libero nisi, imperdiet at, tincidunt nec, gravida vehicula, nisl.</p><h3>Heading 3</h3><p>Lorem ipsum dolor sit amet, adipiscing elit. Nullam dignissim convallis est. Quisque aliquam. Donec faucibus. Nunc iaculis suscipit dui. Nam sit amet sem. Aliquam libero nisi, imperdiet at, tincidunt nec, gravida vehicula, nisl.</p><h4>Heading 4</h4><p>Lorem ipsum dolor sit amet, adipiscing elit. Nullam dignissim convallis est. Quisque aliquam. Donec faucibus. Nunc iaculis suscipit dui. Nam sit amet sem. Aliquam libero nisi, imperdiet at, tincidunt nec, gravida vehicula, nisl.</p><h5>Heading 5</h5><p>Lorem ipsum dolor sit amet, adipiscing elit. Nullam dignissim convallis est. Quisque aliquam. Donec faucibus. Nunc iaculis suscipit dui. Nam sit amet sem. Aliquam libero nisi, imperdiet at, tincidunt nec, gravida vehicula, nisl.</p><h6>Heading 6</h6><p>Lorem ipsum dolor sit amet, adipiscing elit. Nullam dignissim convallis est. Quisque aliquam. Donec faucibus. Nunc iaculis suscipit dui. Nam sit amet sem. Aliquam libero nisi, imperdiet at, tincidunt nec, gravida vehicula, nisl.</p><hr><h1 id=\"block-quote\">Blockquote</h1><hr><p>This is a standard paragraph. Lorem ipsum dolor sit amet, consectetuer adipiscing elit.</p><blockquote>\"<b>This is a blockquote.</b>Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Nullam dignissim convallis est. Quisque aliquam. Donec faucibus. Nunc iaculis suscipit dui. Nam sit amet sem. Aliquam libero nisi, imperdiet at, tincidunt nec, gravida vehicula, nisl.\"</blockquote><p>This is a standard paragraph. Lorem ipsum dolor sit amet, consectetuer adipiscing elit.</p><hr><h1 id=\"text-elements\">Text Elements</h1><hr><p>The<a href=\"#\">a element</a>example</p><p>The<a href=\"http://example.com\" target=\"_blank\">external a element</a>example</p><p>The<cite>cite element</cite>example</p><p>The<b>b element</b>example</p><p>The<i>i element</i>example</p><p>The<small>small element</small>example</p><p>The<sub>sub element</sub>example</p><p>The<sup>sup element</sup>example</p><p>The<u>u element</u>example</p><hr></div>");
}]);
})();

//# sourceMappingURL=ng-komondor.js.map
